<template>
  <div style="padding: 0 10px">
    <div style="text-align: left; margin-bottom: 20px">
      <el-button type="primary" @click="createTemplate">新建</el-button>
    </div>
    <WmsTable
      :columns="columns"
      :dataSource="dataSource"
      @pageChange="pageChangeCall"
      :isPagination="query" 
    >
      <div
        slot="action"
        slot-scope="{ text, record, index }"
        style="
          display: flex;
          justify-content: space-around;
          align-items: center;
        "
      >
        <a href="javaScript:;" @click="edit(record)">编辑</a>
        <a href="javaScript:;" @click="del(record)">删除</a>
      </div>
    </WmsTable>
    <SetBoxTemplate
      ref="SetBoxTemplate"
      @submitCallback="submit"
    ></SetBoxTemplate>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import SetBoxTemplate from "@/views/configure/box/components/SetBoxTemplate";
import { columns } from "@/views/configure/box/indexData";
import { boxTemplatePage, delBox } from "@/apis/configure";
export default {
  title: "箱子",
  name: "ConfigureBox",
  components: {
    SetBoxTemplate,
    WmsTable,
  },
  data() {
    return {
      columns,
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      dataSource: [],
    };
  },
  mounted() {
    this.getDataSource();
  },
  methods: {
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },
    createTemplate: function () {
      this.$refs["SetBoxTemplate"].open();
    },
    edit: function (r) {
      console.log(r);
      this.$refs["SetBoxTemplate"].open(r);
    },
    del: function (r) {
      this.$confirm("确定删除该箱子", "删除提示", {
        confirmButtonText: "确认",
        type: "error",
        cancelButtonText: "取消",
      }).then(() => {
        delBox({boxTemplateId:r.boxTemplateId}).then(({ code }) => {
          if (code === 0) {
            this.$message.success("删除成功");
            this.getDataSource();
          }
        });
      });
    },
    getDataSource: function () {
      const that = this;
      const params = {
        pageNum: that.query.current,
        pageSize: that.query.pageSize,
      };
      boxTemplatePage(params).then(
        ({ code, data: { records = [] }, total }) => {
          if (code === 0) {
            that.dataSource = records;
            that.query.total = total;
          }
        }
      );
    },
    submit(params) {
      this.getDataSource();
    },
  },
};
</script>

<style scoped></style>
